// Text measurement, for auto-fitting a column and for wrapping.
//
// A canvas gives the real width of the real string in the real font — an
// estimate from character counts is wrong by enough to clip a heading, which is
// the one thing auto-fit exists to prevent.

let ctx: CanvasRenderingContext2D | null = null;

const FONT =
  '13px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

function context(): CanvasRenderingContext2D | null {
  if (ctx) return ctx;
  if (typeof document === 'undefined') return null;
  ctx = document.createElement('canvas').getContext('2d');
  return ctx;
}

export function measureText(text: string, bold = false): number {
  const c = context();
  // No canvas (a test runner, a headless capture) — fall back to an estimate
  // rather than failing. It is only ever used to pick a width.
  if (!c) return text.length * 7;
  c.font = bold ? `600 ${FONT}` : FONT;
  return c.measureText(text).width;
}

/** How many lines `text` needs at `width`, wrapping on spaces. */
export function wrappedLines(text: string, width: number, bold = false): number {
  if (text === '') return 1;
  const words = text.split(/\s+/);
  let lines = 1;
  let current = '';
  for (const word of words) {
    const candidate = current === '' ? word : `${current} ${word}`;
    if (measureText(candidate, bold) <= width) {
      current = candidate;
    } else {
      lines += 1;
      current = word;
    }
  }
  return lines;
}
